if (!customElements.get('product-form')) {
	customElements.define('product-form', class ProductForm extends HTMLElement {
		constructor() {
			super();

			this.form = this.querySelector('form');
			this.form.querySelector('[name=id]').disabled = false;
			this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
			this.minicart = document.querySelector('mini-cart');
		}

		onSubmitHandler(event) {
			event.preventDefault();
			const submitButton = this.querySelector('[type="submit"]');
			if (submitButton.classList.contains('loading')) {
				return;
			}

			this.handleErrorMessage();

			const displaySpinner = (show = true) => {
				if (submitButton && submitButton instanceof HTMLElement) {
					if (show) {
						submitButton.setAttribute('disabled', true);
					} else {
						submitButton.removeAttribute('disabled');
					}
				}
			}
			submitButton.setAttribute('aria-disabled', true);
			submitButton.classList.add('loading');
			const origSpinner = this.querySelector('.button-overlay-spinner')
			if (origSpinner && origSpinner instanceof HTMLElement) {
				origSpinner.classList.remove('hidden');
			}
			displaySpinner(true)

			const config = fetchConfig('javascript');
			config.headers['X-Requested-With'] = 'XMLHttpRequest';
			delete config.headers['Content-Type'];

			const formData = new FormData(this.form);

			formData.append('sections', this.minicart.getSectionsToRender().map((section) => section.id));
			formData.append('sections_url', window.location.pathname);

			const defaultUOM = formData.get('default_uom');
			if (defaultUOM) {
				formData.set('properties[UOM]', defaultUOM);
			}
			formData.delete('default_uom');

			
			config.body = formData;

			fetch(`${routes.cart_add_url}`, config)
				.then((response) => response.json())
				.then((response) => {
					if (response.status) {
						this.handleErrorMessage(response.description);
						displaySpinner(false)
						return;
					}

					this.minicart.renderContents(response);

					const toggleLabel = document.querySelector('.t-selector-option-switch');
					if (toggleLabel) {
						toggleLabel.dispatchEvent(new Event('change', { bubbles: true }));
					}
					forceUpdateForPrices()
					this.minicart.open(submitButton);
				})
				.catch((e) => {
					console.error(e);
					displaySpinner(false)
				})
				.finally(() => {
					submitButton.classList.remove('loading');
					submitButton.removeAttribute('aria-disabled');
					const origSpinner = this.querySelector('.button-overlay-spinner')
					if (origSpinner && origSpinner instanceof HTMLElement) {
						origSpinner.classList.add('hidden');
					}
					displaySpinner(false)
				});
		}

		handleErrorMessage(errorMessage = false) {
			if (errorMessage) {
				showCartNotification(errorMessage, false)
			}
		}
	});
}
